<script>
export default {
  name: 'CurrencyField',
  props: {
    value: { type: Number, required: false, default: null },
    currency: { type: String, default: '$' },
    formatter: { type: Function, default: n => n.toFixed(2) }
  },
  computed: {
    stringValue() {
      return this.formatter(this.userInput)
    },
    userInputAsNumber() {
      return parseFloat(this.userInput, 10)
    },
    userInputIsInvalid() {
      return Number.isNaN(this.userInputAsNumber)
    },
    userInputAsCents() {
      return Math.round(this.userInputAsNumber * 100)
    },
    valueAsNonCent() {
      if (this.$props.value === null) {
        return null
      } else {
        return this.$props.value / 100
      }
    }
  },
  data() {
    return {
      userInput: this.$props.value !== null ? this.formatter(this.$props.value / 100) : ''
    }
  },
  methods: {
    onInput(value) {
      this.userInput = value
      if (this.userInputIsInvalid) {
        this.$emit('input', null)
      } else {
        this.$emit('input', this.userInputAsCents)
      }
    }
  },
  watch: {
    value: function(oldValue, newValue) {
      this.userInput = typeof this.valueAsNonCent === 'number' ? this.formatter(this.valueAsNonCent) : ''
    }
  },
  inheritAttrs: false
}
</script>

<template>
  <v-text-field
    type="number"
    :prefix="currency"
    step="0.01"
    min="0"
    :value="userInput"
    @input="onInput"
    v-bind="$attrs"
  />
</template>
